export enum AlloyOutcome {
  Approved = "Approved",
  Denied = "Denied",
  ManualReview = "Manual Review",
  DocumentResubmit = "Document Resubmit",
  PreviouslyApproved = "Previously Approved"
}
